import { useRoutes } from "react-router-dom";
import { CatalogueRoutes } from "@sicarx/sxe-catalogue"
import { View404 } from "@sicarx/sxe-components";

export const IndexRoutes = (() => {
    const IndexRoutes = useRoutes([
        ...CatalogueRoutes,
        { path: "*", element: <View404 /> },
    ]);
    return IndexRoutes;
}) 
